'use strict'
/**
 * Provides a simple configuration object for Solid web client
 * @module config-default
 */
module.exports = {
  /**
   * Default proxy URL for servicing CORS requests
   */
  proxyUrl: 'https://databox.me/,proxy?uri={uri}',
  /**
   * Timeout for web/ajax operations, in milliseconds
   */
  timeout: 50000
}



//////////////////
// WEBPACK FOOTER
// ./~/solid-web-client/config-default.js
// module id = 141
// module chunks = 0